import { getResults } from '.'
import { GET } from 'shared/util/fetch-methods'
import { GifPermissions } from 'shared/types/user-permissions'
import { IGif } from '@giphy/js-types'

type Result = {}
type GifDetailResult = {
    permissions: GifPermissions
    gif: IGif
    has_permissions: boolean
}
let requestMap: { [key: string]: Promise<Result> } = {}

function request<T>(url: string) {
    if (!requestMap[url]) {
        requestMap[url] = getResults(url, GET)
    }
    return requestMap[url] as Promise<T>
}

export function getGifDetailPermissions(gifId) {
    return request<GifDetailResult>(`/ajax/gif/${gifId}/detail`)
}
